import { useRef } from 'react'

import { PktButton } from '@/components/button/Button'
import { PktModal } from '@/components/modal/Modal'

export default function Modal() {
  const dialogRef1 = useRef<HTMLDialogElement>(null)
  const dialogRef2 = useRef<HTMLDialogElement>(null)
  const dialogRef3 = useRef<HTMLDialogElement>(null)
  const dialogRefDrawer = useRef<HTMLDialogElement>(null)
  const dialogRefDrawerLeft = useRef<HTMLDialogElement>(null)
  const dialogRefTransparent = useRef<HTMLDialogElement>(null)
  const dialogRefDrawerTransparent = useRef<HTMLDialogElement>(null)

  return (
    <main className="page-main pkt-container">
      <section className="component" style={{ padding: '2rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <h1>Modal</h1>
        <h2>Variation: defaults</h2>
        <p>padding, closeButton, no backdrop click, size mediuem</p>
        <PktButton
          style={{ width: 'fit-content' }}
          type="button"
          skin="primary"
          onClick={() => {
            dialogRef1.current?.showModal()
            console.log('showModal()')
          }}
        >
          Åpne modal
        </PktButton>
        <PktModal
          headingText="Ønsker du å lagre dine siste endringer?"
          closeOnBackdropClick
          size="medium"
          ref={dialogRef1}
        >
          Du har lagt til endringer i distribusjonsreglene. Ønsker du å lagre dem? Where does it come from? Contrary to
          popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature
          from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in
          Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going
          through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes
          from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by
          Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the
          Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section
          1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.
          Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact
          original form, accompanied by English versions from the 1914 translation by H. Rackham. Where does it come
          from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical
          Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at
          Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem
          Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable
          source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes
          of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular
          during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in
          section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those
          interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in
          their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where does
          it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of
          classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at
          Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem
          Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable
          source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes
          of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular
          during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in
          section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those
          interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in
          their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.
          <form>
            <span className="pkt-modal__btn-wrapper">
              <PktButton type="submit" skin="primary" onClick={() => console.log('Lagre')}>
                Lagre
              </PktButton>
              <PktButton type="button" skin="secondary" onClick={() => console.log('Knappetekst')}>
                Knappetekst
              </PktButton>
              <PktButton
                type="button"
                skin="tertiary"
                onClick={() => {
                  dialogRef1.current?.close()
                  console.log('this.pktModal.close()')
                }}
              >
                Avbryt
              </PktButton>
            </span>
          </form>
        </PktModal>
        Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a
        piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin
        professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur,
        from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the
        undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The
        Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very
        popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line
        in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those
        interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in
        their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where does
        it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of
        classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at
        Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem
        Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable
        source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of
        Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during
        the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section
        1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.
        Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact
        original form, accompanied by English versions from the 1914 translation by H. Rackham. Where does it come from?
        Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin
        literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney
        College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and
        going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum
        comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by
        Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance.
        The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The
        standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32
        and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form,
        accompanied by English versions from the 1914 translation by H. Rackham.
      </section>
      <section className="component">
        <h2>Variation: noHeading, yellowCloseButton, size large</h2>
        <PktButton
          type="button"
          style={{ width: 'fit-content' }}
          skin="secondary"
          onClick={() => {
            dialogRef2.current?.showModal()
            console.log('showModal()')
          }}
        >
          Åpne modal 2
        </PktButton>
        <PktModal closeOnBackdropClick closeButtonSkin="yellow-filled" size="large" ref={dialogRef2}>
          <i>Informasjon til deg</i>
          <h1>Viktig informasjon om din brukeropplevelse</h1>
          Vi har gjort noen endringer som kan påvirke din opplevelse. Les mer for å få den nyeste informasjonen, eller
          lukk denne meldingen hvis du ikke ønsker flere oppdateringer nå. Hampden-Sydney College in Virginia, looked up
          one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of
          the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32
          and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC.
          This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem
          Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum
          used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus
          Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English
          versions from the 1914 translation by H. Rackham. Where does it come from? Contrary to popular belief, Lorem
          Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it
          over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up
          one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of
          the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32
          and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC.
          This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem
          Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum
          used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus
          Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English
          versions from the 1914 translation by H. Rackham.
          <form method="dialog">
            <span className="pkt-modal__btn-wrapper">
              <PktButton type="submit" skin="primary">
                Få mer informasjon
              </PktButton>
              <PktButton type="button" skin="secondary" onClick={() => dialogRef2.current?.close()}>
                Lukk
              </PktButton>
            </span>
          </form>
        </PktModal>
      </section>

      <section className="component">
        <h2>Variation: removePadding, noHeading, yellowCloseButton, size small</h2>
        <PktButton
          style={{ width: 'fit-content' }}
          type="button"
          skin="secondary"
          onClick={() => dialogRef3.current?.showModal()}
        >
          Åpne modal 3
        </PktButton>
        <PktModal removePadding closeOnBackdropClick closeButtonSkin="yellow-filled" size="small" ref={dialogRef3}>
          <i>Informasjon til deg</i>
          <h1>Viktig informasjon om din brukeropplevelse</h1>
          <form method="dialog">
            <span className="pkt-modal__btn-wrapper">
              <PktButton type="submit" skin="primary">
                Få mer informasjon
              </PktButton>
              <PktButton type="button" skin="secondary" onClick={() => dialogRef3.current?.close()}>
                Lukk
              </PktButton>
            </span>
          </form>
        </PktModal>
      </section>

      <section className="component">
        <h2>Variation: Drawer</h2>
        <PktButton
          style={{ width: 'fit-content' }}
          type="button"
          skin="secondary"
          onClick={() => {
            dialogRefDrawer.current?.showModal()
          }}
        >
          Åpne modal drawer
        </PktButton>
        <PktModal
          headingText="Ønsker du å lagre dine siste endringer?"
          closeOnBackdropClick
          size="medium"
          variant="drawer"
          ref={dialogRefDrawer}
        >
          Du har lagt til endringer i distribusjonsreglene. Ønsker du å lagre dem? Where does it come from? Contrary to
          popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature
          from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in
          Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going
          through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes
          from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by
          Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the
          Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section
          1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.
          Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact
          original form, accompanied by English versions from the 1914 translation by H. Rackham. Where does it come
          from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical
          Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at
          Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem
          Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable
          source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes
          of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular
          during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in
          section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those
          interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in
          their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where does
          it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of
          classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at
          Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem
          Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable
          source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes
          of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular
          during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in
          section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those
          interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in
          their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where does
          it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of
          classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at
          Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem
          Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable
          source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes
          <form method="dialog">
            <span className="pkt-modal__btn-wrapper">
              <PktButton type="submit" skin="primary">
                Lagre
              </PktButton>
              <PktButton type="button" skin="secondary" onClick={() => dialogRefDrawer.current?.close()}>
                Knappetekst
              </PktButton>
              <PktButton
                type="button"
                skin="tertiary"
                onClick={() => {
                  dialogRefDrawer.current?.close()
                  console.log('this.pktModal.close()')
                }}
              >
                Avbryt
              </PktButton>
            </span>
          </form>
        </PktModal>
      </section>
      <section className="component">
        <h2>Variation: Drawer, left</h2>
        <PktButton
          style={{ width: 'fit-content' }}
          type="button"
          skin="secondary"
          onClick={() => {
            dialogRefDrawerLeft.current?.showModal()
          }}
        >
          Åpne modal drawer left
        </PktButton>
        <PktModal
          headingText="Ønsker du å lagre dine siste endringer?"
          closeOnBackdropClick
          size="medium"
          variant="drawer"
          drawerPosition="left"
          ref={dialogRefDrawerLeft}
        >
          Du har lagt til endringer i distribusjonsreglene. Ønsker du å lagre dem? Where does it come from? Contrary to
          popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature
          from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in
          Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going
          through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes
          from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by
          Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the
          Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section
          1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.
          Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact
          original form, accompanied by English versions from the 1914 translation by H. Rackham.
        </PktModal>
      </section>
      <section className="component">
        <h2>Variation: Transparent</h2>
        <PktButton
          style={{ width: 'fit-content' }}
          type="button"
          skin="secondary"
          onClick={() => {
            dialogRefTransparent.current?.showModal()
          }}
        >
          Åpne modal transparent
        </PktButton>
        <PktModal
          headingText="Ønsker du å lagre dine siste endringer?"
          closeOnBackdropClick
          size="medium"
          transparentBackdrop
          ref={dialogRefTransparent}
        >
          Du har lagt til endringer i distribusjonsreglene. Ønsker du å lagre dem? Where does it come from? Contrary to
          popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature
          from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in
          Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going
          through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes
          from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by
          Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the
          Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section
          1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.
        </PktModal>
      </section>
      <section className="component">
        <h2>Variation: Drawer, left, transparent</h2>
        <PktButton
          style={{ width: 'fit-content' }}
          type="button"
          skin="secondary"
          onClick={() => {
            dialogRefDrawerTransparent.current?.showModal()
          }}
        >
          Åpne modal drawer left transparent
        </PktButton>
        <PktModal
          headingText="Ønsker du å lagre dine siste endringer?"
          closeOnBackdropClick
          size="medium"
          variant="drawer"
          drawerPosition="left"
          transparentBackdrop
          ref={dialogRefDrawerTransparent}
        >
          Du har lagt til endringer i distribusjonsreglene. Ønsker du å lagre dem? Where does it come from? Contrary to
          popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature
          from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in
          Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going
          through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes
          from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by
          Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the
          Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section
          1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.
          Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact
          <span className="pkt-modal__btn-wrapper">
            <PktButton type="submit" skin="primary">
              Lagre
            </PktButton>
            <PktButton type="button" skin="secondary" onClick={() => dialogRefDrawerTransparent.current?.close()}>
              Knappetekst
            </PktButton>
            <PktButton
              type="button"
              skin="tertiary"
              onClick={() => {
                dialogRefDrawerTransparent.current?.close()
                console.log('this.pktModal.close()')
              }}
            >
              Avbryt
            </PktButton>
          </span>
        </PktModal>
      </section>
    </main>
  )
}
